<script lang="ts">
  import { onMount } from "svelte";
  import type { ClassValue } from "svelte/elements";

  interface Props {
    name: string;
    src: string;
    size?: number;
    class?: ClassValue;
  }

  let { name, src, size = 24, class: className }: Props = $props();

  let imgError = $state(false);
  let mounted = $state(false);

  // svelte-ignore state_referenced_locally
  let adjustedSize = size - 2;

  onMount(() => {
    mounted = true;
  });

  function handleImageError() {
    imgError = true;
  }
</script>

<div
  class={[
    "flex items-center justify-center rounded-full bg-mono-000 p-0.5 shadow-border",
    className,
  ]}
>
  <div
    class="avatar overflow-hidden rounded-full"
    style="width: {adjustedSize}px; height: {adjustedSize}px"
  >
    {#if src && mounted}
      <img
        class="h-full w-full object-cover object-center"
        class:hidden={imgError}
        {src}
        alt={name ? `${name}'s avatar` : "user's avatar"}
        onerror={handleImageError}
      />
    {/if}
    <div
      class="flex h-full w-full items-center justify-center bg-pri-050 bg-gradient-to-r from-pri-200 to-pri-700"
      aria-label="user avatar"
    ></div>
  </div>
</div>
